import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, enviarCentralNominal } from './types';

export const INITIAL_STATE: enviarCentralNominal = {
	status: 0,
	data: {
		atestadoEmitido: '',
		codigoRetorno: '',
		mensagemRetorno: '',
		codigoValidacao: '',
		id: '',
		mensagem: '',
	},
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): enviarCentralNominal {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ENVIAR_CENTRAL_NOMINAL_REQUEST: {
				break;
			}

			case Types.ENVIAR_CENTRAL_NOMINAL_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.ENVIAR_CENTRAL_NOMINAL_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.ENVIAR_CENTRAL_NOMINAL_CLEAN: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}

		return draft;
	});
}
